<template>
  <div
    class="d-flex w-100 flex-column gap-xs step pa-xs justify-space-between pa-lg h-100 bg-white"
  >
    <div class="d-flex gap-sm flex-column">
      <h1 class="font-md blue-darker bold-medium text-align-left">{{ t('check-in.report') }}</h1>

      <p class="grey font-sm">
        {{ t('check-in.reportDescription') }}
      </p>

      <div v-if="type === 'check-in'">
        <UploadIncidentImages
          :files="temporalFiles"
          :is-loading="isLoading"
          @upload-file="handleUploadImage"
          @remove-file="removeImage"
        />
      </div>

      <div>
        <ion-textarea
          v-model.trim="comment"
          fill="solid"
          :label="t('check-in.writeComment')"
          label-placement="floating"
          :placeholder="t('check-in.writeComment')"
        ></ion-textarea>
        <p v-if="comment !== '' && comment.length < 5" class="text-error font-xxs">
          {{ t('validations.minLength', { min: 5 }) }}
        </p>
      </div>
    </div>

    <div></div>

    <div class="d-flex justify-space-between d-flex justify-space-between mt-xs w-100">
      <ion-button
        fill="clear"
        expand="block"
        size="default"
        color="primary"
        class="text-lg text-weight-bold"
        @click="$emit('cancel')"
      >
        {{ t('actions.cancel') }}
      </ion-button>

      <ion-button
        :disabled="
          comment === '' ||
          isLoading ||
          comment.length < 5 ||
          (type === 'check-in' && temporalFiles.length === 0)
        "
        fill="solid"
        expand="block"
        size="default"
        color="primary"
        class="text-lg text-weight-bold"
        @click="handleCreateReport()"
      >
        {{ t('check-in.createReport') }}
      </ion-button>
    </div>
  </div>
</template>
<script setup lang="ts">
/* eslint-disable */
  import { IonButton, IonTextarea } from '@ionic/vue';
  import { useI18n } from 'vue-i18n';
  import { onMounted, ref } from 'vue';
  import { useToast } from '@/composables/useToast';
  import UploadIncidentImages from './UploadIncidentImages.vue';
  import { useCheck } from '@/composables/useCheck';
  import { GeneralQuestion } from '@/interfaces/check/check-in.interface';

  const props = withDefaults(
    defineProps<{
      question: GeneralQuestion;
      showModal: boolean;
      type: string;
      bookingId: string;
    }>(),
    {},
  );

  const temporalFiles = ref<string[]>([]);
  const { t } = useI18n();
  const comment = ref('');
  const isLoading = ref(false);
  const emit = defineEmits(['continue', 'cancel', 'close']);
  const { showToast } = useToast();
  const { uploadImage } = useCheck();

  const handleCreateReport = () => {
    props.question.comment = comment.value;
    props.question.images = temporalFiles.value;
    showToast(t('check-in.reportSaved'));

    emit('continue');
  };

  const removeImage = (index: number) => {
    temporalFiles.value.splice(index, 1);
  };

  const handleUploadImage = async (img64: string) => {
    isLoading.value = true;
    const data = await uploadImage(img64, props.question, props.bookingId, props.type);

    if (data) {
      temporalFiles.value.push(data.urlFile);
    }
    isLoading.value = false;
  };

  const checkInitialDataQuestion = () => {
    if (props.question.images && props.question.images.length > 0) {
      temporalFiles.value = props.question.images;
    }
    if (props.question.comment !== null && props.question.comment !== '') {
      comment.value = props.question.comment;
    }
  };

  onMounted(() => {
    checkInitialDataQuestion();
  });
</script>

<style lang="css" scoped>
  .text-error {
    color: var(--ion-error);
    position: absolute;
  }
</style>
